<app-breadcrumb [title]="'dashboard.homeTitle' | translate" 
[items]="[]" 
[active_item]="''">
</app-breadcrumb>


<!-- statics -->
<div class="container-fluid">
  <div class="row widget-grid">
    <div class="col">
    <div class="row">
      <div class="col-12">
        <div class="card-header dashboard-page-header border-0 bg-transparent px-0 pt-0">
          <p class="dashboard-page-header__subtitle text-muted small mb-0" *ngIf="user_type == 100 || user_type == 101">
            {{ 'dashboard.homeSubtitle' | translate }}
          </p>
        </div>
      </div>
    </div>
    
    <!-- ═══════  Merchant v2 Dashboard (user_type 100/101)  ═══════ -->
    <div *ngIf="user_type == 100 || user_type == 101" class="dash-merchant-v2">

      <!-- Loading -->
      <div *ngIf="merchantDashboardLoading" class="dash-v2-skeleton-wrap">
        <div class="dash-v2-skeleton-quick-actions mb-4"></div>
        <div class="dash-v2-skeleton-financial mb-4"></div>
        <div class="row g-3 mb-4">
          <div class="col-lg-6"><div class="dash-v2-skeleton-chart-tall"></div></div>
          <div class="col-lg-6"><div class="dash-v2-skeleton-chart-tall"></div></div>
        </div>
      </div>

      <!-- Error -->
      <div *ngIf="!merchantDashboardLoading && merchantDashboardError" class="text-center py-5">
        <i class="fa fa-exclamation-triangle fa-3x text-warning mb-3"></i>
        <p class="text-muted">{{ curentLang === 'en' ? 'Failed to load dashboard data' : (curentLang === 'ar' ? 'فشل في تحميل بيانات لوحة التحكم' : 'טעינת הנתונים נכשלה') }}</p>
        <button class="btn btn-outline-brand btn-sm" (click)="loadMerchantDashboardV2()">
          <i class="fa fa-refresh me-1"></i>{{ curentLang === 'en' ? 'Retry' : (curentLang === 'ar' ? 'إعادة المحاولة' : 'נסה שוב') }}
        </button>
      </div>

      <!-- Dashboard content -->
      <ng-container *ngIf="!merchantDashboardLoading && merchantDashboardStats">

        <!-- Subscription inactive alert -->
        <div class="alert alert-danger d-flex align-items-center gap-2 mb-3" role="alert"
             *ngIf="merchantDashboardStats.subscription && !merchantDashboardStats.subscription.is_active">
          <i class="fa fa-exclamation-circle fa-lg"></i>
          <span>{{ curentLang === 'en' ? 'Your subscription is inactive or expired.' : (curentLang === 'ar' ? 'اشتراكك غير مفعّل أو منتهي.' : 'המנוי שלך לא פעיל או פג.') }}</span>
          <a class="btn btn-sm btn-brand ms-auto" routerLink="/dashboard/invoice-subscriptions">
            {{ curentLang === 'en' ? 'Manage subscription' : (curentLang === 'ar' ? 'إدارة الاشتراك' : 'ניהול מנוי') }}
          </a>
        </div>

        <!-- ── Quick Actions ── -->
        <section class="dash-quick-actions mb-4">
          <h6 class="dash-section-title mb-3">{{ 'dashboard.quickActions.title' | translate }}</h6>
          <div class="dash-quick-actions__grid">
            <a *ngFor="let action of quickActions"
               class="dash-quick-action-card"
               [routerLink]="action.route"
               [queryParams]="action.queryParams">
              <span class="dash-quick-action-card__icon" [style.background]="action.color + '18'" [style.color]="action.color">
                <i class="fa" [ngClass]="action.icon"></i>
              </span>
              <span class="dash-quick-action-card__label">{{ action.labelKey | translate }}</span>
            </a>
          </div>
        </section>

        <!-- ── Financial Summary ── -->
        <section class="card border-0 shadow-sm dash-financial-summary mb-4" *ngIf="!merchantDashboardLoading">
          <div class="card-header bg-transparent border-0 pt-3 px-4 pb-2">
            <h6 class="mb-1 fw-semibold">{{ 'dashboard.financialSummary' | translate }}</h6>
            <p class="text-muted small mb-0">{{ 'dashboard.financialSummaryHint' | translate }}</p>
          </div>
          <div class="card-body px-4 pb-3">
            <div class="dash-empty-state text-center py-4" *ngIf="!hasSelectedCompany()">
              <i class="fa fa-building-o dash-empty-state__icon"></i>
              <p class="mb-0 text-muted">{{ 'dashboard.noCompanySelected' | translate }}</p>
            </div>
            <div class="dash-empty-state text-center py-4" *ngIf="hasSelectedCompany() && !financialSummary()">
              <i class="fa fa-bar-chart dash-empty-state__icon"></i>
              <p class="mb-0 text-muted">{{ 'dashboard.noFinancialData' | translate }}</p>
            </div>
            <ng-container *ngIf="financialSummary() as fs">
            <div class="dash-empty-state text-center py-4" *ngIf="!hasFinancialData()">
              <i class="fa fa-bar-chart dash-empty-state__icon"></i>
              <p class="mb-0 text-muted">{{ 'dashboard.noFinancialData' | translate }}</p>
            </div>
            <ng-container *ngIf="hasFinancialData()">
            <div class="dash-financial-tabs d-lg-none mb-3">
              <button type="button" class="dash-financial-tabs__btn"
                      [class.dash-financial-tabs__btn--active]="mobileFinancialTab === 'current_month'"
                      (click)="setMobileFinancialTab('current_month')">
                {{ 'dashboard.periods.currentMonth' | translate }}
              </button>
              <button type="button" class="dash-financial-tabs__btn"
                      [class.dash-financial-tabs__btn--active]="mobileFinancialTab === 'previous_month'"
                      (click)="setMobileFinancialTab('previous_month')">
                {{ 'dashboard.periods.previousMonth' | translate }}
              </button>
              <button type="button" class="dash-financial-tabs__btn"
                      [class.dash-financial-tabs__btn--active]="mobileFinancialTab === 'year_to_date'"
                      (click)="setMobileFinancialTab('year_to_date')">
                {{ 'dashboard.periods.yearToDate' | translate }}
              </button>
            </div>
            <div class="dash-financial-mobile d-lg-none" *ngIf="mobileFinancialPeriod() as mp">
              <p class="dash-financial-mobile__range text-muted small mb-3">
                <i class="fa fa-calendar-o me-1"></i>{{ formatPeriodRangeShort(mp) }}
              </p>
              <div class="dash-financial-mobile__metric dash-financial-mobile__metric--income">
                <span class="dash-financial-mobile__label">{{ 'dashboard.rows.income' | translate }}</span>
                <span class="dash-financial-mobile__value">₪{{ mp.income | number:'1.0-0' }}</span>
              </div>
              <div class="dash-financial-mobile__metric dash-financial-mobile__metric--expenses">
                <span class="dash-financial-mobile__label">{{ 'dashboard.rows.expenses' | translate }}</span>
                <span class="dash-financial-mobile__value">₪{{ mp.expenses | number:'1.0-0' }}</span>
              </div>
              <div class="dash-financial-mobile__metric dash-financial-mobile__metric--profit">
                <span class="dash-financial-mobile__label">{{ 'dashboard.rows.profit' | translate }}</span>
                <span class="dash-financial-mobile__value">₪{{ mp.profit | number:'1.0-0' }}</span>
              </div>
              <div class="dash-financial-comparison mt-3" *ngIf="mp.comparison_percent != null">
                <span class="dash-growth-badge" [ngClass]="growthClass(mp.comparison_percent)">{{ growthLabel(mp.comparison_percent) }}</span>
                <span class="dash-growth-desc">{{ comparisonLabel(mobileFinancialTab) }}</span>
              </div>
            </div>
            <div class="table-responsive d-none d-lg-block">
              <table class="table dash-financial-table mb-0">
                <thead>
                  <tr>
                    <th>{{ 'dashboard.financialSummaryMetric' | translate }}</th>
                    <th>
                      <div class="dash-financial-col-head dash-financial-col-head--current">
                        <i class="fa fa-calendar"></i>
                        <span>{{ 'dashboard.periods.currentMonth' | translate }}</span>
                        <small>{{ formatPeriodRange(desktopFinancialPeriod('current_month')) }}</small>
                      </div>
                    </th>
                    <th>
                      <div class="dash-financial-col-head dash-financial-col-head--prev">
                        <i class="fa fa-calendar-o"></i>
                        <span>{{ 'dashboard.periods.previousMonth' | translate }}</span>
                        <small>{{ formatPeriodRange(desktopFinancialPeriod('previous_month')) }}</small>
                      </div>
                    </th>
                    <th>
                      <div class="dash-financial-col-head dash-financial-col-head--ytd">
                        <i class="fa fa-calendar-check-o"></i>
                        <span>{{ 'dashboard.periods.yearToDate' | translate }}</span>
                        <small>{{ formatPeriodRange(desktopFinancialPeriod('year_to_date')) }}</small>
                      </div>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr class="dash-financial-table__row--income">
                    <td>{{ 'dashboard.rows.income' | translate }}</td>
                    <td>₪{{ fs.current_month.income | number:'1.0-0' }}</td>
                    <td>₪{{ fs.previous_month.income | number:'1.0-0' }}</td>
                    <td>₪{{ fs.year_to_date.income | number:'1.0-0' }}</td>
                  </tr>
                  <tr class="dash-financial-table__row--expenses">
                    <td>{{ 'dashboard.rows.expenses' | translate }}</td>
                    <td>₪{{ fs.current_month.expenses | number:'1.0-0' }}</td>
                    <td>₪{{ fs.previous_month.expenses | number:'1.0-0' }}</td>
                    <td>₪{{ fs.year_to_date.expenses | number:'1.0-0' }}</td>
                  </tr>
                  <tr class="dash-financial-table__row--profit">
                    <td>{{ 'dashboard.rows.profit' | translate }}</td>
                    <td>₪{{ fs.current_month.profit | number:'1.0-0' }}</td>
                    <td>₪{{ fs.previous_month.profit | number:'1.0-0' }}</td>
                    <td>₪{{ fs.year_to_date.profit | number:'1.0-0' }}</td>
                  </tr>
                </tbody>
                <tfoot>
                  <tr class="dash-financial-table__comparison">
                    <td></td>
                    <td *ngIf="fs.current_month.comparison_percent != null">
                      <span class="dash-growth-badge" [ngClass]="growthClass(fs.current_month.comparison_percent)">{{ growthLabel(fs.current_month.comparison_percent) }}</span>
                      <span class="dash-growth-desc">{{ comparisonLabel('current_month') }}</span>
                    </td>
                    <td *ngIf="fs.previous_month.comparison_percent != null">
                      <span class="dash-growth-badge" [ngClass]="growthClass(fs.previous_month.comparison_percent)">{{ growthLabel(fs.previous_month.comparison_percent) }}</span>
                      <span class="dash-growth-desc">{{ comparisonLabel('previous_month') }}</span>
                    </td>
                    <td *ngIf="fs.year_to_date.comparison_percent != null">
                      <span class="dash-growth-badge" [ngClass]="growthClass(fs.year_to_date.comparison_percent)">{{ growthLabel(fs.year_to_date.comparison_percent) }}</span>
                      <span class="dash-growth-desc">{{ comparisonLabel('year_to_date') }}</span>
                    </td>
                  </tr>
                </tfoot>
              </table>
            </div>
            </ng-container>
            </ng-container>
          </div>
        </section>

        <div class="row g-3 mb-4 dash-widgets-row">
          <div class="col-lg-6 order-lg-1 order-1">
            <div class="card border-0 shadow-sm h-100 dash-expenses-type">
              <div class="card-header bg-transparent border-0 d-flex align-items-center justify-content-between pt-3 px-4 pb-1">
                <h6 class="mb-0 fw-semibold">{{ 'dashboard.expensesByType' | translate }}</h6>
                <div class="d-none d-lg-flex align-items-center gap-2">
                  <i *ngIf="expensePeriodLoading" class="fa fa-spinner fa-spin text-muted" style="font-size:0.85rem;"></i>
                  <select class="form-select form-select-sm dash-trend-filter"
                          [(ngModel)]="selectedExpensePeriod"
                          (ngModelChange)="onExpensePeriodChange()"
                          [disabled]="expensePeriodLoading">
                    <option value="current_month">{{ 'dashboard.periods.currentMonth' | translate }}</option>
                    <option value="previous_month">{{ 'dashboard.periods.previousMonth' | translate }}</option>
                  </select>
                </div>
              </div>
              <div class="card-body px-4 pb-3">
                <div class="dash-empty-state text-center py-4" *ngIf="!hasExpenseTypeData()">
                  <i class="fa fa-pie-chart dash-empty-state__icon"></i>
                  <p class="mb-0 text-muted">{{ 'dashboard.noExpensesData' | translate }}</p>
                </div>
                <div class="d-none d-lg-block" *ngIf="hasExpenseTypeData()">
                  <div class="d-flex align-items-center gap-3 dash-status-row">
                    <div class="dash-status-chart-wrap flex-shrink-0">
                      <canvas baseChart [data]="expensesTypeChartData" [options]="expensesTypeChartOptions" type="doughnut"></canvas>
                      <div class="dash-donut-center">
                        <span class="dash-donut-center__num">₪{{ expensesTypeTotal() | number:'1.0-0' }}</span>
                        <span class="dash-donut-center__label">{{ 'dashboard.totalExpenses' | translate }}</span>
                      </div>
                    </div>
                    <div class="dash-status-legend flex-grow-1 dash-expense-legend">
                      <div class="dash-expense-legend__header">
                        <span class="dash-expense-legend__head-dot"></span>
                        <span class="dash-expense-legend__head-type">{{ 'dashboard.expenseLegend.type' | translate }}</span>
                        <span class="dash-expense-legend__head-amount">{{ 'dashboard.expenseLegend.amount' | translate }}</span>
                        <span class="dash-expense-legend__head-pct">{{ 'dashboard.expenseLegend.percentage' | translate }}</span>
                      </div>
                      <button type="button" class="dash-status-legend__item dash-status-legend__item--clickable dash-expense-legend__row w-100 border-0 bg-transparent text-start"
                              *ngFor="let item of expenseTypeItems(); let i = index"
                              (click)="onExpenseTypeClick(item)">
                        <span class="dash-status-legend__dot" [style.background]="expenseCategoryColor(item.key, i)"></span>
                        <span class="dash-status-legend__label">{{ expenseBucketLabel(item) }}</span>
                        <span class="dash-status-legend__count">₪{{ item.amount | number:'1.0-0' }}</span>
                        <span class="dash-status-legend__pct">{{ item.percentage }}%</span>
                      </button>
                    </div>
                  </div>
                </div>
                <div class="dash-expenses-type__list d-lg-none" *ngIf="hasExpenseTypeData()">
                  <div class="dash-expense-list-item" *ngFor="let item of expenseTypeItems(); let i = index" (click)="onExpenseTypeClick(item)">
                    <div class="dash-expense-list-item__head">
                      <span class="dash-expense-list-item__label">{{ expenseBucketLabel(item) }}</span>
                      <span class="dash-expense-list-item__amount">₪{{ item.amount | number:'1.0-0' }}</span>
                      <span class="dash-expense-list-item__pct">{{ item.percentage }}%</span>
                    </div>
                    <div class="dash-expense-list-item__bar">
                      <div class="dash-expense-list-item__bar-fill" [style.width.%]="item.percentage" [style.background]="expenseCategoryColor(item.key, i)"></div>
                    </div>
                  </div>
                </div>
                <div class="mt-3 text-end">
                  <button type="button" class="dash-view-all-link border-0 bg-transparent" (click)="navigateToExpensesReport()">
                    <i class="fa fa-chevron-{{ curentLang !== 'en' ? 'left' : 'right' }}" style="font-size:0.7rem;"></i>
                    <span class="d-none d-lg-inline">{{ 'dashboard.viewExpensesReport' | translate }}</span>
                    <span class="d-lg-none">{{ 'dashboard.viewDetails' | translate }}</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-6 order-lg-2 order-2">
            <div class="card border-0 shadow-sm h-100">
              <div class="card-header bg-transparent border-0 d-flex align-items-center justify-content-between pt-3 px-4 pb-1">
                <h6 class="mb-0 fw-semibold dash-trend-title">{{ 'dashboard.incomeOrReceiptsLast6Months' | translate }}</h6>
                <div class="d-flex align-items-center gap-2 flex-shrink-0">
                  <i *ngIf="trendFilterLoading" class="fa fa-spinner fa-spin text-muted" style="font-size:0.85rem;"></i>
                  <select class="form-select form-select-sm dash-trend-filter" [(ngModel)]="selectedTrendFilter" (ngModelChange)="onTrendFilterChange()" [disabled]="trendFilterLoading">
                    <option value="income">{{ 'dashboard.trendIncome' | translate }}</option>
                    <option value="receipts">{{ 'dashboard.trendReceipts' | translate }}</option>
                  </select>
                </div>
              </div>
              <div class="card-body px-4 pt-2 pb-3">
                <div class="dash-trend-chart-wrap">
                  <canvas baseChart [data]="trendLineChartData" [options]="trendLineChartOptions" type="line"></canvas>
                </div>
                <div class="mt-3 text-end">
                  <button type="button" class="dash-view-all-link border-0 bg-transparent" (click)="navigateToTrendInvoiceDetails()">
                    <i class="fa fa-chevron-{{ curentLang !== 'en' ? 'left' : 'right' }}" style="font-size:0.7rem;"></i>
                    {{ 'dashboard.viewDetails' | translate }}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- ── Pending payment CTA ── -->
        <!-- ── Pending payment CTA ── -->
        <div class="row g-3 mb-4" *ngIf="merchantDashboardStats.payments?.latest_pending_payment_link?.payment_url">
          <div class="col-12">
            <div class="card border-0 shadow-sm" style="border-inline-start: 4px solid #E62E2D !important;">
              <div class="card-body d-flex flex-wrap align-items-center justify-content-between gap-3">
                <div>
                  <h6 class="mb-1 text-brand">{{ curentLang === 'en' ? 'Pending payment' : (curentLang === 'ar' ? 'دفعة معلّقة' : 'תשלום ממתין') }}</h6>
                  <span class="text-muted small">{{ merchantDashboardStats.payments.latest_pending_payment_link.order_id }} · ₪{{ merchantDashboardStats.payments.latest_pending_payment_link.amount }}</span>
                </div>
                <div class="d-flex gap-2">
                  <button type="button" class="btn btn-outline-brand btn-sm" (click)="copyDashboardPaymentLink(merchantDashboardStats.payments.latest_pending_payment_link.payment_url)">
                    <i class="fa fa-copy me-1"></i>{{ curentLang === 'en' ? 'Copy link' : (curentLang === 'ar' ? 'نسخ الرابط' : 'העתק') }}
                  </button>
                  <a class="btn btn-brand btn-sm" [href]="merchantDashboardStats.payments.latest_pending_payment_link.payment_url" target="_blank" rel="noopener noreferrer">
                    <i class="fa fa-credit-card me-1"></i>{{ curentLang === 'en' ? 'Pay now' : (curentLang === 'ar' ? 'ادفع الآن' : 'שלם עכשיו') }}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>

      </ng-container>
    </div>

    <!---->

    <div class="row  d-flex justify-content-between" *ngIf="user_type == 200 || user_type == 201">
      <div class="col-xxl-4 col-sm-6 box-col-6 ">
        <div class="card profile-box">
          <div class="card-body">
            <div class="media">
              <div class="media-body">
                <div class="greeting-user">
                  <h5 class="f-w-600"> {{ curentLang === 'en' ? 'Welcome to THI Invoices' : (curentLang === 'ar' ? ' مرحبا بكم في THI Invoices' : '    ברוכים הבאים ל-THI Invoices  ')}}</h5>
                  <p> {{ curentLang === 'en' ? 'THere whats happing in your account ' : (curentLang === 'ar' ? ' هنا ما يحدث في حسابك ' : ' הנה מה קורה בחשבון שלך x   ')}} </p>
                  <div class="whatsnew-btn"><a class="btn " style="background-color: transparent; color: transparent;"> {{ curentLang === 'en' ? 'Whats New !' : (curentLang === 'ar' ? ' ما هو جديد  ' : ' הנה מה חדש  ')}}</a></div>
                </div>
              </div>
              <div>
                <div class="clockbox">
                  <svg id="clock" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 600 600">
                    <!-- رموز الساعة -->
                  </svg>
                </div>
                <div class="badge f-10 p-0" id="txt"></div>
              </div>
            </div>
            <div class="cartoon"><img class="img-fluid" src="assets/images/dashboard/cartoon.svg" alt="vector women with leptop" /></div>
          </div>
        </div>
      </div>

      <div class="col-md-8 ">
        <div class="row">
          <div class="col-xxl-4 col-sm-6 box-col-6">
            <div class="card small-widget">
              <div class="card-body {{ newOrders.colorClass }}">
                <span class="f-light">{{ curentLang === 'en' ? 'Number Of Documents ' : (curentLang === 'ar' ? ' عدد المستندات ' : 'מספר מסמכים  ') }}</span>
                <div class="d-flex align-items-end gap-1">
                  <h4 style="color: grey;">{{ allAnalyticsSubplansData.invoiceCount }}</h4>
                </div>
                <div class="bg-gradient">
                  <svg class="stroke-icon svg-fill">
                    <use attr.xlink:href="assets/svg/icon-sprite.svg#{{ newOrders.icon }}"></use>
                  </svg>
                </div>
              </div>
            </div>
          </div>
          <!---->
          <div class="col-xxl-4 col-sm-6 box-col-6">
            <div class="card small-widget">
              <div class="card-body {{ newOrders.colorClass3 }}">
                <span class="f-light">{{ curentLang === 'en' ? 'Number Of Merchant' : (curentLang === 'ar' ? '   عدد التجار    ' : 'מספר סוחרים      ') }}</span>
                <div class="d-flex align-items-end gap-1">
                  <h4 style="color: grey;">{{ allAnalyticsSubplansData?.merchantCount }}</h4>
                </div>
                <div class="bg-gradient">
                  <svg class="stroke-icon svg-fill">
                    <use attr.xlink:href="assets/svg/icon-sprite.svg#{{ newOrders.icon }}"></use>
                  </svg>
                </div>
              </div>
            </div>
          </div>
          <!---->
          <div class="col-xxl-4 col-sm-6 box-col-6">
            <div class="card small-widget">
              <div class="card-body {{ newOrders.colorClass2 }}">
                <span class="f-light">{{ curentLang === 'en' ? 'Number Of Companies' : (curentLang === 'ar' ? '    عدد المصالح التجارية    ' : '     מספר חברות       ') }}</span>
                <div class="d-flex align-items-end gap-1">
                  <h4 style="color: grey;">{{ allAnalyticsSubplansData?.companyCount }}</h4>
                </div>
                <div class="bg-gradient">
                  <svg class="stroke-icon svg-fill">
                    <use attr.xlink:href="assets/svg/icon-sprite.svg#{{ newOrders.icon }}"></use>
                  </svg>
                </div>
              </div>
            </div>
          </div>
          <!---->
          <div class="col-xxl-4 col-sm-6 box-col-6 mt-3">
            <div class="card small-widget">
              <div class="card-body {{ newOrders.colorClass2 }}">
                <span class="f-light">{{ curentLang === 'en' ? 'Number Of Users' : (curentLang === 'ar' ? ' عدد المستخدمين  ' : '  מספר משתמשים  ') }}</span>
                <div class="d-flex align-items-end gap-1"> 
                  <h4 style="color: grey;">{{ allAnalyticsSubplansData?.userCount }}</h4>
                </div>
                <div class="bg-gradient">
                  <svg class="stroke-icon svg-fill">
                    <use attr.xlink:href="assets/svg/icon-sprite.svg#{{ newOrders.icon2 }}"></use>
                  </svg>
                </div>
              </div>
            </div>
          </div>
             <!---->
             <div class="col-xxl-4 col-sm-6 box-col-6 mt-3">
              <div class="card small-widget">
                <div class="card-body {{ newOrders.colorClass4 }}">
                  <span class="f-light">{{ curentLang === 'en' ? 'Number Of Subscribed Merchants' : (curentLang === 'ar' ? '  عدد التجار المشتركين   ' : 'מספר הסוחרים המשתתפים') }}</span>
                  <div class="d-flex align-items-end gap-1"> 
                    <h4 style="color: grey;">{{ allAnalyticsSubplansData.merchantSubscribedCount }}</h4>
                  </div>
                  <div class="bg-gradient">
                    <svg class="stroke-icon svg-fill">
                      <use attr.xlink:href="assets/svg/icon-sprite.svg#{{ newOrders.icon3 }}"></use>
                    </svg>
                  </div>
                </div>
              </div>
            </div>

             <!---->
             <div class="col-xxl-4 col-sm-6 box-col-6 mt-3">
              <div class="card small-widget">
                <div class="card-body {{ newOrders.colorClass }}">
                  <span class="f-light">{{ curentLang === 'en' ? 'Merchant Not Subscribed Count' : (curentLang === 'ar' ? '  عدد التجار الغير المشترك ' : ' מספר סוחרים שאינם משתתפים') }}</span>
                  <div class="d-flex align-items-end gap-1"> 
                    <h4 style="color: grey;">{{ allAnalyticsSubplansData.merchantNotSubscribedCount }}</h4>
                  </div>
                  <div class="bg-gradient">
                    <svg class="stroke-icon svg-fill">
                      <use attr.xlink:href="assets/svg/icon-sprite.svg#{{ newOrders.icon2 }}"></use>
                    </svg>
                  </div>
                </div>
              </div>
            </div>

        </div>
      </div>
    
  
    </div>


    <div class="row  d-flex justify-content-between" *ngIf="user_type == 300 || user_type == 301">
      

      <div class="col-md-12">
        <div class="row">
          <div class="col-xxl-3 col-lg-4  col-sm-12 box-col-6">
            <div class="card small-widget">
              <div class="card-body {{ newOrders.colorClass }}">
                <span class="f-light">{{ curentLang === 'en' ? 'Monthly office statistics ' : (curentLang === 'ar' ? ' إحصائيات المكتب الشهرية' : 'סטטיסטיקות משרדיות חודשיות') }}</span>
                <div class="d-flex align-items-end gap-1">
                  <h4 style="color: grey;" >
                  <i class="fa fa-bar-chart-o" style="font-size: 25px;"></i>
                  </h4>
                </div>
                <div class="bg-gradient">
                  <svg class="stroke-icon svg-fill">
                    <use attr.xlink:href="assets/svg/icon-sprite.svg#{{ newOrders.icon }}"></use>
                  </svg>
                </div>
              </div>
            </div>
          </div>
          <!---->
          <div class="col-xxl-3 col-lg-4  col-sm-12 box-col-6">
            <div class="card small-widget">
              <div class="card-body {{ newOrders.colorClass3 }}">
                <span class="f-light">{{ curentLang === 'en' ? 'Requests Accepted' : (curentLang === 'ar' ? ' الطلبات المقبولة   ' : 'הבקשות התקבלו ') }}</span>
                <div class="d-flex align-items-end gap-1">
                  <h4 style="color: grey;">{{ allOfficeStatisticsData?.month?.agreed }}</h4>
                </div>
                <div class="bg-gradient">
                  <svg class="stroke-icon svg-fill">
                    <use attr.xlink:href="assets/svg/icon-sprite.svg#{{ newOrders.icon }}"></use>
                  </svg>
                </div>
              </div>
            </div>
          </div>
          <!---->
          <div class="col-xxl-3 col-lg-4  col-sm-12 box-col-6">
            <div class="card small-widget">
              <div class="card-body {{ newOrders.colorClass2 }}">
                <span class="f-light">{{ curentLang === 'en' ? 'Pending Requests' : (curentLang === 'ar' ? ' طلبات قيد الأنتظار   ' : 'בקשות ממתינות') }}</span>
                <div class="d-flex align-items-end gap-1">
                  <h4 style="color: grey;">{{ allOfficeStatisticsData?.month?.pending }}</h4>
                </div>
                <div class="bg-gradient">
                  <svg class="stroke-icon svg-fill">
                    <use attr.xlink:href="assets/svg/icon-sprite.svg#{{ newOrders.icon }}"></use>
                  </svg>
                </div>
              </div>
            </div>
          </div>
          <!---->
          <div class="col-xxl-3 col-lg-4  col-sm-12 box-col-6 ">
            <div class="card small-widget">
              <div class="card-body {{ newOrders.colorClass2 }}">
                <span class="f-light">{{ curentLang === 'en' ? 'Rejected Requests' : (curentLang === 'ar' ? 'الطلبات المرفوضة' : 'הבקשות נדחו') }}</span>
                <div class="d-flex align-items-end gap-1"> 
                  <h4 style="color: grey;">{{ allOfficeStatisticsData?.month?.rejected}}</h4>
                </div>
                <div class="bg-gradient">
                  <svg class="stroke-icon svg-fill">
                    <use attr.xlink:href="assets/svg/icon-sprite.svg#{{ newOrders.icon2 }}"></use>
                  </svg>
                </div>
              </div>
            </div>
          </div>
             <!---->
             <div class="col-xxl-3 col-lg-4  col-sm-12 box-col-6  ">
              <div class="card small-widget">
                <div class="card-body {{ newOrders.colorClass }}">
                  <span class="f-light">{{ curentLang === 'en' ? 'Annual office statistics ' : (curentLang === 'ar' ? ' إحصائيات المكتب السنوية' : 'סטטיסטיקה שנתית של משרד') }}</span>
                  <div class="d-flex align-items-end gap-1">
                    <h4 style="color: grey;">
                    <i class="fa fa-bar-chart-o" style="font-size: 25px;"></i>
                    </h4>
                  </div>
                  <div class="bg-gradient">
                    <svg class="stroke-icon svg-fill">
                      <use attr.xlink:href="assets/svg/icon-sprite.svg#{{ newOrders.icon }}"></use>
                    </svg>
                  </div>
                </div>
              </div>
            </div>

             <!---->
             <div class="col-xxl-3 col-lg-4  col-sm-12 box-col-6">
              <div class="card small-widget">
                <div class="card-body {{ newOrders.colorClass3 }}">
                  <span class="f-light">{{ curentLang === 'en' ? 'Requests Accepted' : (curentLang === 'ar' ? ' الطلبات المقبولة   ' : 'הבקשות התקבלו ') }}</span>
                  <div class="d-flex align-items-end gap-1">
                    <h4 style="color: grey;">{{ allOfficeStatisticsData?.year?.agreed }}</h4>
                  </div>
                  <div class="bg-gradient">
                    <svg class="stroke-icon svg-fill">
                      <use attr.xlink:href="assets/svg/icon-sprite.svg#{{ newOrders.icon }}"></use>
                    </svg>
                  </div>
                </div>
              </div>
            </div>
            <!---->
            <div class="col-xxl-3 col-lg-4  col-sm-12 box-col-6">
              <div class="card small-widget">
                <div class="card-body {{ newOrders.colorClass2 }}">
                  <span class="f-light">{{ curentLang === 'en' ? 'Pending Requests' : (curentLang === 'ar' ? ' طلبات قيد الأنتظار   ' : 'בקשות ממתינות') }}</span>
                  <div class="d-flex align-items-end gap-1">
                    <h4 style="color: grey;">{{ allOfficeStatisticsData?.year?.pending }}</h4>
                  </div>
                  <div class="bg-gradient">
                    <svg class="stroke-icon svg-fill">
                      <use attr.xlink:href="assets/svg/icon-sprite.svg#{{ newOrders.icon }}"></use>
                    </svg>
                  </div>
                </div>
              </div>
            </div>
            <!---->
            <div class="col-xxl-3 col-lg-4  col-sm-12 box-col-6 ">
              <div class="card small-widget">
                <div class="card-body {{ newOrders.colorClass2 }}">
                  <span class="f-light">{{ curentLang === 'en' ? 'Rejected Requests' : (curentLang === 'ar' ? 'الطلبات المرفوضة' : 'הבקשות נדחו') }}</span>
                  <div class="d-flex align-items-end gap-1"> 
                    <h4 style="color: grey;">{{ allOfficeStatisticsData?.year?.rejected}}</h4>
                  </div>
                  <div class="bg-gradient">
                    <svg class="stroke-icon svg-fill">
                      <use attr.xlink:href="assets/svg/icon-sprite.svg#{{ newOrders.icon2 }}"></use>
                    </svg>
                  </div>
                </div>
              </div>
            </div>

        </div>
      </div>
    
  
    </div>

    </div>
    </div>
  </div>
<!---->

<!-- sub plans (hidden for merchant 100/101 — they use v2 dashboard) -->
<div class="container-fluid" *ngIf="user_type != 300 && user_type != 100 && user_type != 101" [hidden]="user_type == 301">
  <app-subscription-plans></app-subscription-plans>
</div>

<!---->

<!--Merchant Subscription Plans-->

<!-- <div class="container-fluid basic_table" *ngIf="user_type == 100">
    <div class="row">
<div class="col-sm-12">
    <div class="card">
      <div class="card-header">
        <h5 style="color: grey;">
            {{ curentLang === 'en' ? 'Merchant subscription plans' : (curentLang === 'ar' ? 'خطط الأشتراك الخاصة بالتاجر' : 'תוכניות מנוי לסוחר')}}
        </h5>
     
      </div>
      <div class="card-block row">
        <div class="col-sm-12 col-lg-12 col-xl-12">
          <div class="table-responsive">
            <table class="table table-light text-center table-hover  " >
              <thead>
                <tr>
                  <th scope="col">{{ curentLang === 'en' ? 'index' : (curentLang === 'ar' ? '  م' : '  מ ') }}</th>
                  <th scope="col"> {{ curentLang === 'en' ? 'Plan Name' : (curentLang === 'ar' ? '  اسم الخطة' : '  שם התוכנית')}} </th>
                  <th scope="col"> {{ curentLang === 'en' ? 'Price' : (curentLang === 'ar' ? '  السعر' : '  מחיר')}}</th>
                  <th scope="col"> {{ curentLang === 'en' ? 'Amount Paid' : (curentLang === 'ar' ? '  المبلغ المدفوع' : '  כמות שולמה')}}</th>
                  <th scope="col"> {{ curentLang === 'en' ? 'Payment Type' : (curentLang === 'ar' ? '   نوع الدفع' : '   סוג תשלום')}}</th>
                  <th scope="col">{{ curentLang === 'en' ? 'Number Of Documents' : (curentLang === 'ar' ? ' عدد المستندات' : ' מספר מסמכים')}}</th>
                  <th scope="col"> {{ curentLang === 'en' ? 'Documents Remaining' : (curentLang === 'ar' ? ' المستندات المتبقية' : ' מסמכים נשארו')}}</th>
                  <th scope="col"> {{ curentLang === 'en' ? 'Number Of Companies' : (curentLang === 'ar' ? ' عدد المصالح التجارية' : ' מספר חברות')}}</th>
                  <th scope="col"> {{ curentLang === 'en' ? 'Number Of Users' : (curentLang === 'ar' ? ' عدد المستخدمين' : ' מספר משתמשים')}}</th>
                  <th scope="col"> {{ curentLang === 'en' ? 'Status' : (curentLang === 'ar' ? 'الحالة' : 'סטטוס')}}</th>
                  <th scope="col"> {{ curentLang === 'en' ? 'Created Date' : (curentLang === 'ar' ? '  تاريخ التسجيل' : '  תאריך הרשמ')}}</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let item of subPlansByMerchant | paginate: {itemsPerPage:7, currentPage:p } |filter:term ; let i = index ">
                  <td scope="row">{{i+1}}</td>
                  <td> {{curentLang === 'en' ? item.subscribeToPlanDetails[0]?.plan_name_en : (curentLang === 'ar' ? item.subscribeToPlanDetails[0]?.plan_name_ar : item.subscribeToPlanDetails[0]?.plan_name_he)}}</td>
                  <td> {{item.subscribeToPlanDetails[0]?.price}}</td>
                  <td>{{item.subscribeToPlanDetails[0]?.amount_paid}}</td>
                  <td>{{item.subscribeToPlanDetails[0]?.payment_type}}</td>
                  <td>{{item.number_of_documents}}</td>
                  <td>{{ item.documents_remaining}}</td>
                  <td>{{item.number_of_company}}</td>
                  <td>{{item.number_of_users}}</td>
                  <td *ngIf="item.status == 1" class="font-success">{{ curentLang === 'en' ? 'Avilable' : (curentLang === 'ar' ? ' متوفر' : ' זמין')}}</td>
                  <td>{{ item.createdDate | date:'shortDate'}}</td>
                </tr>
          
              </tbody>
            </table>
            <pagination-controls (pageChange)="p = $event" class="m-auto my-3 current" > </pagination-controls>                

          </div>
        </div>
      </div>
    </div>
  </div>

    </div>
</div> -->

